export const EXPERIENCE_LEVEL = [
  { value: 'ENTRY_LEVEL', label: 'Entry Level' },
  { value: 'MID_SENIOR_LEVEL', label: 'Mid Senior Level' },
  { value: 'SENIOR_LEVEL', label: 'Senior Level' },
  { value: 'INTERNSHIP', label: 'Internship' },
  { value: 'ASSOCIATE', label: 'Associate' },
  { value: 'DIRECTOR', label: 'Director' },
  { value: 'EXECUTIVE', label: 'Executive' }
];

export const POST_PER_PAGE = 10;

export const CAD_SALARY_OPTIONS = [
  { value: '1, 20000', label: 'below $20000' },
  { value: '20000, 30000', label: '$20000 - $30000' },
  { value: '30000, 40000', label: '$30000 - $40000' },
  { value: '40000, 50000', label: '$40000 - $50000' },
  { value: '50000, 60000', label: '$50000 - $60000' },
  { value: '60000, 70000', label: '$60000 - $70000' },
  { value: '70000, 80000', label: '$70000 - $80000' },
  { value: '80000, 90000', label: '$80000 - $90000' },
  { value: '90000, 100000', label: '$90000 - $100000' },
  { value: '100000, 110000', label: 'more than $100000' },
  { value: '0, 0', label: 'Negotiable' }
];

export const RMB_SALARY_OPTIONS = [
  { value: '0, 20000', label: '￥20000 以下' },
  { value: '20000, 30000', label: '￥20000 - ￥30000' },
  { value: '30000, 40000', label: '￥30000 - ￥40000' },
  { value: '40000, 50000', label: '￥40000 - ￥50000' },
  { value: '50000, 60000', label: '￥50000 - ￥60000' },
  { value: '60000, 70000', label: '￥60000 - ￥70000' },
  { value: '70000, 80000', label: '￥70000 - ￥80000' },
  { value: '80000, 90000', label: '￥80000 - ￥90000' },
  { value: '90000, 100000', label: '￥0000 - ￥100000' },
  { value: '100000, 0', label: '￥100000 以上' },
  { value: '0, 0', label: '面议' }
];



// WEBPACK FOOTER //
// ./src/components/postings/constant.js